import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { forkJoin } from "rxjs";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { PromotionsService } from "src/app/features/promotions/promotions.service";

@Component({
  selector: "app-edit-consumer-banner-smart-promotions",
  template: "<app-edit-consumer-banner [codeGroups]='codeGroups' [serviceCountries]='serviceCountries' [carrierDetails]='carrierDetails'></app-edit-consumer-banner>",
  styles: [],
})
export class EditConsumerBannerSmartComponent
  extends FeaturesBaseComponent
  implements OnInit
{
  serviceCountries: [];
  codeGroups: [];
  carrierDetails: [];
  productId: any;
  constructor(
    private promotionService: PromotionsService,
    private activatedRoute: ActivatedRoute
  ) {
    super();
    this.getAllProductServiceData();
  }

  getAllProductServiceData() {
    this.productId = this.activatedRoute.snapshot.params.id;
    let carrierDetails = this.promotionService.getConsumerPromotionById(
      this.productId
    );
    let codeGroups = this.promotionService.getcodeGroups();
    let serviceCountries = this.promotionService.getCarrierCountries();

    forkJoin([carrierDetails, codeGroups, serviceCountries]).subscribe(
      (res) => {
        this.carrierDetails = res[0]["data"];
        this.codeGroups = res[1].data;
        this.serviceCountries = res[2]["data"];
      }
    );
  }
}
